<script setup lang="ts">

import {Icon} from "@iconify/vue";
import {useFileHistoryActionButtons} from "@/composables/useFileHistoryActionButtons.ts";
import type {HistoryEntry} from "@/services/historyDb.ts";

const {entry} = defineProps<{
  entry: HistoryEntry;
}>();
const {onDelete, onDownload, onReuse, isBusy} = useFileHistoryActionButtons(() => entry)

</script>

<template>
  <div  class="flex shrink-0 items-center gap-1">
    <button
        type="button"
        class="btn btn-ghost !px-2 !py-1.5"
        :disabled="isBusy"
        title="In Editor laden"
        aria-label="In Editor laden"
        @click.stop="onReuse"
    >
      <Icon icon="fa6-solid:arrow-rotate-left" class="text-sm"/>
    </button>
    <button
        type="button"
        class="btn btn-ghost !px-2 !py-1.5"
        :disabled="isBusy"
        title="Herunterladen"
        aria-label="Herunterladen"
        @click.stop="onDownload"
    >
      <Icon icon="fa6-solid:download" class="text-sm"/>
    </button>
    <button
        type="button"
        class="btn btn-ghost !px-2 !py-1.5 text-red-500 hover:bg-red-50 hover:text-red-600"
        :disabled="isBusy"
        title="Löschen"
        aria-label="Löschen"
        @click.stop="onDelete"
    >
      <Icon icon="fa6-solid:trash" class="text-sm"/>
    </button>

  </div>
</template>

<style scoped>

</style>